import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    userDetails: {},
    isReload: false
}

export const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        setUserDetails: (state, action) => ({...state, userDetails: action.payload}),
        setIsReload: (state) => ({...state, isReload: !state.isReload}),
    }
})

export const {setUserDetails, setIsReload } = userSlice.actions

const userReducer = userSlice.reducer
export default userReducer
